import React from 'react';

import asArray from 'utils/arrays/asArray.util'; // Since this is experiment, we can share the same .module.scss file
import fromAnyToTrimmed from 'utils/converters/any/fromAnyToTrimmed.util';
import fromAnyToString from 'utils/converters/fromAnyToString';
import fromEntriesToObject from 'utils/converters/object/fromEntriesToObject.util';
import alwaysSame from 'utils/functions/nullary/alwaysSame.util';
import logger from 'utils/logger.util';
import asObject from 'utils/objects/asObject.util';
import createNodeKey from 'utils/react/createNodeKey.util';

import CN from './PalettePanel.module.scss';

const L = logger('PalettePanel');

const rulesFor = (options) => (prev, rule) => {
  const prefix = fromAnyToString(options?.prefix);

  const selectorText = fromAnyToString(rule.selectorText);
  if (selectorText && !selectorText.includes(options?.selector)) {
    return asArray(prev);
  }

  const byPrefix = prefix ? ([name]) => fromAnyToTrimmed(name).startsWith(prefix) : alwaysSame;

  const next = rule.cssText
    .split('{')[1]
    .replace('}', '')
    .split(';')
    .map((line) => {
      const prop = line.split(':');
      const isCustom = prop.length === 2 && prop[0].indexOf('--') === 1;

      return isCustom ? [prop[0], prop[1]] : null;
    })
    .filter(alwaysSame)
    .filter(byPrefix);

  return [...asArray(prev), ...next];
};

const sheetsFor = (options) => (prev, sheet) => {
  const { cssRules, href } = asObject(sheet);
  if (href || !cssRules) {
    return asArray(prev);
  }

  const next = [...cssRules].reduce(rulesFor(options), []);

  return [...asArray(prev), ...next];
};

const PalettePanel = () => {
  const options = { selector: ':root', prefix: '--c-' };
  const entries = [...document.styleSheets].reduce(sheetsFor(options), []);

  L.debug('()', fromEntriesToObject(entries));

  return (
    <div data-bem="PalettePanel">
      <div className={CN.colors}>
        {entries.map(([key, val], index) => (
          <div className={CN.row} data-key={key} data-val={val} key={createNodeKey({ index })}>
            <div className={CN.key}>{key}</div>
            <div className={CN.val}>{val}</div>
            <div className={CN.clr} style={{ backgroundColor: `var(${key})` }}>
              &nbsp;
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

// noinspection JSUnusedGlobalSymbols
export default PalettePanel;
